import {
  ADD_SELECTED_OFFERS,
  CLEAR_SELECTED_OFFERS,
  CLOSE_SELECT_OFFER_DIALOG,
  CREATE_PURCHARSE_ORDER,
  DELETE_SELECTED_OFFERS,
  DISABLE_LOWER_OFFER,
  DISABLE_OTHER_OFFER_TOTAL,
  DISABLE_OTHER_OFFER,
  ENABLE_OTHER_OFFER,
  GET_SELECTION_CRITERIA_ERROR,
  GET_SELECTION_CRITERIA_SUCCESS,
  LOWES_VALUE_OFFER__ERROR,
  LOWES_VALUE_OFFER_SUCCESS,
  LOWES_VALUE_OFFER,
  SAVE_PURCHASE_ORDER_ERROR,
  SAVE_PURCHASE_ORDER_SUCCESS,
  SAVE_PURCHASE_ORDER,
  SELECT_LOWEST_OFFER,
  SET_CRITERIA_PURCHASE_ORDER,
  SET_VALIDATION_INPUT_GROUP,
  SHOW_SELECT_OFFER_DIALOG,
  VALIDATION_INPUT_GROUP
} from './SelectOfferDialog.actions'

const selectOfferDialogState = {
  disableOtherOffer: false,
  disableOtherOfferTotal: false,
  errors: [],
  isOfferLowerPrice: false,
  loading: false,
  loadingSelected: false,
  isFailedSelected: false,
  purchaseOrderInfo: null,
  purchaseOrders: [],
  selectedOffers: [],
  selectionCriteria: [],
  showSelectOfferDialog: false,
  showSelectOfferErrorModal: false,
  validationInputGroup: []
}

/**
 * The select offer dialog's reducer.
 */
const selectOfferDialogReducer = (state = selectOfferDialogState, { payload, type }) => {
  switch (type) {
    case ADD_SELECTED_OFFERS: {
      return { ...state, selectedOffers: [...state.selectedOffers, payload.offerId] }
    }
    case CLEAR_SELECTED_OFFERS: {
      return { ...state, selectedOffers: [] }
    }
    case CLOSE_SELECT_OFFER_DIALOG: {
      return { ...state, showSelectOfferDialog: false }
    }
    case CREATE_PURCHARSE_ORDER: {
      return { ...state, purchaseOrders: payload }
    }
    case DELETE_SELECTED_OFFERS: {
      return { ...state, selectedOffers: [...state.selectedOffers.filter(item => item !== payload.offerId)] }
    }
    case DISABLE_LOWER_OFFER: {
      return { ...state, isOfferLowerPrice: false }
    }
    case DISABLE_OTHER_OFFER: {
      return { ...state, disableOtherOffer: true }
    }
    case DISABLE_OTHER_OFFER_TOTAL: {
      return { ...state, disableOtherOfferTotal: true }
    }
    case ENABLE_OTHER_OFFER: {
      return { ...state, disableOtherOffer: false, disableOtherOfferTotal: false, isOfferLowerPrice: false }
    }
    case GET_SELECTION_CRITERIA_SUCCESS: {
      return { ...state, selectionCriteria: [...payload.selectionCriteria], error: false }
    }
    case GET_SELECTION_CRITERIA_ERROR: {
      return { ...state, error: true }
    }
    case SELECT_LOWEST_OFFER: {
      return { ...state, isOfferLowerPrice: true }
    }
    case SAVE_PURCHASE_ORDER: {
      return { ...state, loading: true }
    }
    case SAVE_PURCHASE_ORDER_ERROR: {
      return { ...state, errors: payload.errors, loading: false }
    }
    case SAVE_PURCHASE_ORDER_SUCCESS: {
      return { ...state, purchaseOrderInfo: payload }
    }
    case SET_CRITERIA_PURCHASE_ORDER: {
      return {
        ...state,
        purchaseOrders: {
          ...state.purchaseOrders,
          purchaseOrder: [
            ...state.purchaseOrders.purchaseOrder.map(offer => ({
              ...offer,
              selectionCriteria: payload.offer === offer.idOffer ? payload.selectionCriteria : offer.selectionCriteria
            }))
          ]
        }
      }
    }
    case SET_VALIDATION_INPUT_GROUP: {
      return {
        ...state,
        validationInputGroup: state.validationInputGroup.map(input => ({
          ...input,
          validation: input.ref === payload.id ? payload.validation : input.validation
        }))
      }
    }
    case SHOW_SELECT_OFFER_DIALOG: {
      return { ...state, showSelectOfferDialog: true }
    }
    case VALIDATION_INPUT_GROUP: {
      return { ...state, validationInputGroup: payload.input }
    }
    case LOWES_VALUE_OFFER: {
      return { ...state, loadingSelected: true, isFailedSelected: false }
    }
    case LOWES_VALUE_OFFER_SUCCESS: {
      return { ...state, loadingSelected: false, isFailedSelected: false }
    }
    case LOWES_VALUE_OFFER__ERROR: {
      return { ...state, loadingSelected: false, isFailedSelected: true }
    }
    default: {
      return state
    }
  }
}

export default selectOfferDialogReducer
